import React, { useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../config";
import { useNavigate } from "react-router-dom";
import "../components/Login.css";

function Login() {
  const [isLogin, setIsLogin] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const navigate = useNavigate();

  const handleSubmit = async () => {
    // 1. Validation
    if (!email || !password || (!isLogin && !username)) {
      alert("Please fill all fields");
      return;
    }

    // URL exactly matches your browser folder name: HOTEL-API
    const url = isLogin
      ? `${API_BASE_URL}/login.php`
      : `${API_BASE_URL}/signup.php`;

    try {
      const res = await axios.post(
        url,
        { username, email, password },
        { 
          headers: { 
            "Content-Type": "application/json" 
          } 
        }
      );

      const data = typeof res.data === "string" ? JSON.parse(res.data) : res.data;

      if (data.status === "success") {
        if (!isLogin) {
          // --- UPDATED FLOW FOR SIGNUP ---
          alert("Account created successfully! Please log in to your new account.");
          setIsLogin(true); // Switches UI back to Login mode
          setUsername("");  // Clear fields
          setPassword("");
        } else {
          // --- FLOW FOR LOGIN ---
          alert("Login Successful!");
          navigate("/dashboard");
        }
      } else {
        alert(data.message);
      }
    } catch (err) {
      console.error("Connection Details:", err);
      alert("Server not connected. Check if XAMPP Apache is Running!");
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="logo">🏨</div>
        <h1>Hotel Tuljai</h1>
        <p className="subtitle">
          {isLogin ? "Admin Panel Login" : "Admin Panel Signup"}
        </p>

        {!isLogin && (
          <input
            type="text"
            placeholder="Username"
            className="input-field"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        )}

        <input
          type="email"
          placeholder="Email"
          className="input-field"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <div className="password-box">
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <span
            className="eye"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? "🙈" : "👁️"}
          </span>
        </div>

        <button className="login-btn" onClick={handleSubmit}>
          {isLogin ? "Login" : "Signup"}
        </button>

        <p className="switch">
          {isLogin ? "Don't have an account?" : "Already have an account?"}
          <span 
            onClick={() => setIsLogin(!isLogin)} 
            style={{cursor: 'pointer', color: '#B3471D', fontWeight: 'bold'}}
          >
            {isLogin ? " Signup" : " Login"}
          </span>
        </p>

        <p className="footer">© 2026 Hotel Tuljai. All rights reserved.</p>
      </div>
    </div>
  );
}

export default Login;